var _circle, _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSuccessful = function SvgIconSuccessful(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#C3F78C",
    fillOpacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    x: 11.5,
    y: 11.5,
    fill: "#C3F78C",
    rx: 20.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    x: 11.5,
    y: 11.5,
    stroke: "#C3F78C",
    rx: 20.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m39.546 27-10 10L25 32.455"
  })));
};
export default SvgIconSuccessful;